
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.609 5.681c1.937 0 3.67 1.212 4.312 3.017l.225.631.641-.212c.276-.091.56-.142.8-.142 1.125 0 2.093.757 2.353 1.84l.126.523h.869c1.862 0 3.378 1.492 3.378 3.325 0 1.834-1.516 3.326-3.378 3.326H5.065c-1.862 0-3.378-1.492-3.378-3.326 0-1.62 1.18-2.997 2.805-3.274l.633-.107-.066-.633a4.59 4.59 0 01-.024-.464c0-2.484 2.052-4.504 4.574-4.504zm0-.681c-2.905 0-5.262 2.322-5.262 5.185 0 .18.01.36.028.534C2.465 11.045 1 12.691 1 14.663c0 2.203 1.83 4.006 4.065 4.006h13.87c2.236 0 4.065-1.803 4.065-4.006 0-2.203-1.83-4.006-4.065-4.006h-.326a3.103 3.103 0 00-3.022-2.363c-.357 0-.719.078-1.018.178A5.253 5.253 0 009.61 5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.985 16.45h-6.66l.007-.346c.03-1.657 1.102-3.052 2.522-3.441a2.209 2.209 0 01-1.424-2.057c0-1.216.998-2.205 2.225-2.205 1.226 0 2.225.988 2.225 2.204 0 .936-.592 1.738-1.425 2.057 1.42.389 2.493 1.784 2.523 3.44l.007.348zm-5.941-.68h5.222c-.18-1.426-1.292-2.534-2.611-2.534-1.32 0-2.431 1.109-2.611 2.533zm2.61-6.688c-.847 0-1.537.684-1.537 1.524s.69 1.524 1.538 1.524c.848 0 1.537-.684 1.537-1.524s-.69-1.524-1.537-1.524z","fill":"currentColor"}})])
          )
        }
      }
    